<div class="add-edit-master-data-block">
<section class="ei-popup">
<form class="ei-popup-form">
    <div class="form-container">

            <div class="form-field">
                <label>Category</label>
                <mat-form-field appearance="outline">
                    <mat-select class="virtual-scroll" name="category" [(ngModel)]="categoryForm"
                         placeholder="Select category" (selectionChange)="checkForChanges()" panelClass="dropdown-options-width">
                        <mat-option *ngFor="let option of uniqueCategory" [value]="option">
                            {{ option }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="form-field">
                <label>Public/Private Cloud</label>
                    <mat-form-field appearance="outline">
                        <mat-select class="virtual-scroll" name="Public/Private Cloud" [(ngModel)]="PVCloud"
                         placeholder="Select Public/Private Cloud" (selectionChange)="checkForChanges()" panelClass="dropdown-options-width">
                        <mat-option *ngFor="let option of uniquePublicPrivate" [value]="option">
                            {{ option }}
                        </mat-option>
                        </mat-select>
                    </mat-form-field>
            </div>
        <div class="form-field">
            <label>Edit TOH</label>
            <mat-form-field appearance="outline">
                <mat-select class="virtual-scroll" (selectionChange)="editTohChanged()" name="Edit_TOH" [(ngModel)]="editToh"
                     placeholder="Select Edit TOH" panelClass="dropdown-options-width">
                <mat-option *ngFor="let option of editTohData" [value]="option">
                    {{ option }}
                </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="form-field">
            <label>SRV Disable</label>
                <mat-form-field appearance="outline">
                    <mat-select class="virtual-scroll" [disabled]="editToh === 'Yes'" (selectionChange)="checkForChanges()" name="srv_Disabled" [(ngModel)]="srvDisabled"
                      placeholder="Select SRV Disable" panelClass="dropdown-options-width">
                    <mat-option *ngFor="let option of editTohData" [value]="option">
                        {{ option }}
                    </mat-option>
                    </mat-select>
                </mat-form-field>
        </div>


    </div>

    <div class="form-container mt-2">
        <div class="form-field">
            <label>External Link</label>
            <mat-form-field [disableRipple]="true"  appearance="outline" class="inline-form-edit chip-select-stakeholder select-user-dropdown" floatLabel="never">
    
                <input class="virtual-scroll" name="externalLink" (input)="checkForChanges()" placeholder="External Link" matInput [(ngModel)]="externalLink">
    
            </mat-form-field>
    
        </div>
    </div>





    <div class="user-management-action-block">
        <div class="row select-section">
            <div class=" col-md-6 col-sm-6 col-lg-6 col-xl-6 col-xs-6">
                <div class="add-section">
                    <div class="form-group service-owner-block w-40">
                        <label>Service Owner</label>
                        <mat-form-field [disableRipple]="true"  appearance="outline" class="inline-form-edit chip-select-stakeholder select-user-dropdown" floatLabel="never">

                            <input placeholder="Search by Name/Mail (min 4 chars)" [ngClass]="{'no-input-field' : selectedAddUserslist?.length > 0}" matInput  [matAutocomplete]="auto" (keyup)="onSearchUser($event)"
                                [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes">
                            <mat-autocomplete showPanel=true class="lob-options-list" #auto="matAutocomplete"
                                (optionSelected)="getSelectedUsers($event)">
                            
                                <mat-option [disabled]="user?.disable" *ngFor="let user of searchUserList"
                                    title="{{ user.MSId }}<{{ user.displayName }}>({{ user.mail }})" [value]="user">
                                    {{ user.MSId||user.msid }}<{{ user.displayName }}>({{ user.mail }})
                                </mat-option>
                            </mat-autocomplete>
                            <mat-chip-grid #chipList style="margin-top: 2px;">
                                <ng-container *ngIf=" nameArray?.length > 0">
                                    <mat-chip-row class="stk-mat-chip" *ngFor="let selectedUsers of nameArray;let i = index" (removed)="removeSelectedUser(i)">
                                        {{selectedUsers}} 
                                        <mat-icon matChipRemove>cancel</mat-icon>
                                    </mat-chip-row>
                                </ng-container>
                            </mat-chip-grid>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-sm-6 col-lg-6 col-xl-6 col-xs-6">
                <div class="form-group text-area-block">
                    <label>UI Comments</label>
                    <textarea type="textarea" class="form-control" (input)="checkForChanges()" name="UI Comments"
                        [(ngModel)]="UI_Comments" minlength="3" maxlength="300"> </textarea>
                </div>
            </div>
        </div>
    </div>

</form>
</section>
<section class="submit-button">
<button [disabled]="!isAnyChange"
    class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs"
    (click)="updateForecast()"> Submit
</button>
</section>
</div>
